import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';

export const TransferUnauthView: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6 text-center">
            <div className="bg-gray-900 p-8 rounded-2xl shadow-lg border border-gray-800 max-w-sm w-full">
                <LogIn className="w-12 h-12 text-violet-500 mx-auto mb-4" />
                <h2 className="text-xl font-bold text-white mb-2">Login Required</h2>
                <p className="text-gray-400 mb-6 text-sm">
                    Please login to view or accept this transfer.
                </p>
                <button
                    onClick={() => navigate('/login')}
                    className="w-full py-3 rounded-xl bg-violet-600 text-white font-bold hover:bg-violet-500 transition"
                >
                    Log In / Sign Up
                </button>
            </div>
        </div>
    );
};

export default TransferUnauthView;
